"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _classnames = _interopRequireDefault(require("classnames"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _values = _interopRequireDefault(require("lodash/values"));

var _class, _class2, _descriptor, _class3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

var TooltipDirections = {
  TOP: "top",
  BOTTOM: "bottom",
  RIGHT: "right",
  LEFT: "left"
};
var tooltipDirectionValues = (0, _values.default)(TooltipDirections);
var defaultHorizontalDirection = TooltipDirections.RIGHT;
var defaultVerticalDirection = TooltipDirections.BOTTOM;

var isDirectionHorizontal = function isDirectionHorizontal(direction) {
  return direction === TooltipDirections.RIGHT || direction === TooltipDirections.LEFT;
};

var TooltipContent = (0, _mobxReact.observer)(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
  _inherits(TooltipContent, _React$Component);

  var _super = _createSuper(TooltipContent);

  function TooltipContent(props) {
    var _this;

    _classCallCheck(this, TooltipContent);

    _this = _super.call(this, props);

    _initializerDefineProperty(_assertThisInitialized(_this), "horizontalAdjustment", _descriptor, _assertThisInitialized(_this));

    _this.tooltipRef = /*#__PURE__*/_react.default.createRef();
    return _this;
  }

  _createClass(TooltipContent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var tooltipContent = this.tooltipRef.current; // make sure we only set horizontalAdjustment once

      if (tooltipContent && this.horizontalAdjustment === 0) {
        if (tooltipContent.getBoundingClientRect().left < 0) {
          this.horizontalAdjustment = Math.abs(tooltipContent.getBoundingClientRect().left);
        } else if (!(0, _isUndefined.default)(window) && window.screen && tooltipContent.getBoundingClientRect().right > (window.screen.availWidth || window.screen.width)) {
          this.horizontalAdjustment = Math.abs(tooltipContent.getBoundingClientRect().right - (window.screen.availWidth || window.screen.width));
        }
      }
    }
  }, {
    key: "getSecondaryDirection",
    value: function getSecondaryDirection(primaryDirection) {
      var isPrimaryHorizontal = isDirectionHorizontal(primaryDirection);
      var useDefault = (0, _isUndefined.default)(this.props.secondaryDirection) || isPrimaryHorizontal === isDirectionHorizontal(this.props.secondaryDirection);

      if (useDefault) {
        return isPrimaryHorizontal ? defaultVerticalDirection : defaultHorizontalDirection;
      } else {
        return this.props.secondaryDirection;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var direction = this.props.direction || defaultHorizontalDirection;
      var secondaryDirection = this.getSecondaryDirection(direction);
      var mountClasses = ["tooltip-mount", "primary-".concat(direction), "secondary-".concat(secondaryDirection)]; // allow for horizontal adjustments to be applied at 50px increments

      var contentClasses = (0, _classnames.default)("tooltip-content", this.props.className, {
        "adjusted-50": this.horizontalAdjustment > 0 && this.horizontalAdjustment <= 50,
        "adjusted-100": this.horizontalAdjustment > 50 && this.horizontalAdjustment <= 100,
        "adjusted-150": this.horizontalAdjustment > 100 && this.horizontalAdjustment <= 150,
        "adjusted-200": this.horizontalAdjustment > 150 && this.horizontalAdjustment <= 200,
        "adjusted-250": this.horizontalAdjustment > 200 && this.horizontalAdjustment <= 250,
        "adjusted-300": this.horizontalAdjustment > 250 && this.horizontalAdjustment <= 300
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(mountClasses),
        style: this.props.style
      }, this.props.visible && /*#__PURE__*/_react.default.createElement("div", {
        ref: this.tooltipRef,
        className: contentClasses
      }, this.props.children));
    }
  }]);

  return TooltipContent;
}(_react.default.Component), _defineProperty(_class3, "propTypes", {
  visible: _propTypes.default.bool,
  direction: _propTypes.default.oneOf(tooltipDirectionValues),
  secondaryDirection: _propTypes.default.oneOf(tooltipDirectionValues),
  includeHideButton: _propTypes.default.bool,
  hide: _propTypes.default.func,
  className: _propTypes.default.string,
  style: _propTypes.default.object // only use if absolutely necessary

}), _defineProperty(_class3, "defaultProps", {
  direction: defaultHorizontalDirection,
  secondaryDirection: defaultVerticalDirection,
  includeHideButton: false
}), _class3), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "horizontalAdjustment", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
})), _class2)) || _class;

TooltipContent.Directions = TooltipDirections;
var _default = TooltipContent;
exports.default = _default;